@import "src/helpers/ScreenSizes.scss"; //mixins for different screen sizes

.otpScreen {
  @include windowSizes();
  border: 1px solid #c5c5ca;
  border-radius: 20px;
  background-color: white;
  overflow: auto;
}

.closeButtonContainer {
  display: flex;
  justify-content: flex-end;
  padding: 21px 21px 0 0;
}

.otp {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0 10px 15px 10px;
}

.otpHeaderMargin {
  margin-top: 11px;
  margin-bottom: 24px;
  font-family: "Inter";
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 24px;
  text-align: center;
  font-feature-settings: "liga" off;

  color: #39393a;

  @include small() {
    margin-top: 24px;
  }
}

.otpButtonDiv {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-bottom: 15px;
  position: -webkit-sticky; /* Safari */
  position: sticky;
  bottom: 15px;
  background-color: white;
  @include small() {
    padding-left: 24px;
    padding-right: 24px;
  }
}

.otpContinueButton {
  max-width: 376px;
  width: 100%;
  height: 48px;
  background-color: #16182b;
  border-radius: 24px;
  align-self: center;
  justify-content: center;
  align-items: center;

  margin: 38px 24px 0px 24px;

  font-family: "Inter";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  color: #ffffff;
  cursor: pointer;

  @include small() {
    margin: 18px 24px 0px 24px;
  }
}

.srcMark {
  display: flex;
  align-self: center;
  padding: 5px 0px;
}

.otpSubtitle {
  margin-top: 16px;
  margin-bottom: 16px;

  font-family: "Inter";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;

  padding-left: 72px;
  padding-right: 72px;

  text-align: center;
  font-feature-settings: "liga" off;

  color: #39393a;
  white-space: pre-line;

  @include small() {
    max-width: 200px;
    padding-left: 24px;
    padding-right: 24px;
  }
}

.otpText {
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 20px;

  padding-left: 72px;
  padding-right: 72px;

  text-align: center;
  font-feature-settings: "liga" off;

  color: #39393a;
  white-space: pre-line;

  @include small() {
    max-width: 300px;
    padding-left: 24px;
    padding-right: 24px;
  }
}

.otpRememberMeSection {
  box-sizing: border-box;
  width: 100%;
  max-width: 376px;
  margin-top: 18px;

  @include small() {
    max-width: 330px;
  }
}

.resendButton {
  background-color: transparent;
  border: none;
  align-self: center;
  margin-top: 22px;

  text-align: center;
  font-family: "Inter";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 19px;
  font-feature-settings: "liga" off;
  color: #16182b;
  cursor: pointer;

  @include small {
    margin-top: 8px;
  }
}
